import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import { main_links } from 'config';

const PopupConfirmChange = ({ execActionConfirm = null }) => {
    
    const [isLoading, setIsLoading] = useState(false);
    const [pathRedirect, setPathRedirect] = useState('');
    const handleConfirm = (event) => {
        event.preventDefault();
        if(isLoading) return;

        setIsLoading(true);
        setTimeout(function(){
            execActionConfirm && execActionConfirm();
        }, 1500);
    }
    const handleCancel = (event) => {
        event.preventDefault();
        if(isLoading) return;
        setPathRedirect(main_links.main_logged);
    }

    return (
        <div id="message-popup-change" className="white-popup message-popup-simple">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 p-0">
                                <p className="text-center mb-4 red"><strong>¿Estás seguro que no deseas<br/>agregar más cupones?</strong></p>
                                <p className="text-center mb-4">Procederemos a generar tu código de canje. Recuerda que solo puedes utilizar un código por cada ticket de compra. </p>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <p className="text-center">
                                            <a href="#" onClick={(event) => handleCancel(event)} className="btn px-2">Agregar cupones</a>
                                        </p>
                                    </div>
                                    <div className="col-12 col-md-6 m-0">
                                        <div className="text-center">
                                            <a href="#" onClick={(event) => handleConfirm(event)} className="btn button-popup-terms">
                                                {isLoading?<Loading type="metro--hover size-xs" />:'Continuar'}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {pathRedirect!=='' && <Redirect to={pathRedirect} />}
        </div>
    )
};

PopupConfirmChange.propTypes = {
    execActionConfirm: PropTypes.func
};
export default PopupConfirmChange;
